import React, { useState } from 'react';
import axios from 'axios';
import Register from './Register';  // Assuming you have Register component in the same directory
import Login from './Login';        // Assuming you have Login component in the same directory

const DatabaseConnectionChecker = () => {
  const [connectionStatus, setConnectionStatus] = useState(null);
  const [message, setMessage] = useState('');
  const [isRegistered, setIsRegistered] = useState(false); // to toggle between login and register forms

  const checkConnection = async () => {
    try {
      const response = await axios.get('https://weynibirhan.com.et/test-connection.php'); // Replace this with your actual backend URL
      const data = response.data;
      setConnectionStatus(data.status);
      setMessage(data.message);
    } catch (error) {
      setConnectionStatus('error');
      setMessage('Error connecting to the server.');
    }
  };

  const toggleForm = () => {
    setIsRegistered(!isRegistered); // Toggle between register and login form
  };

  return (
    <div>

      <div>
        {isRegistered ? (
          <Login />  
        ) : (
          <Register />  
        )}

        <button onClick={toggleForm}>
          {isRegistered ? 'Need an account? Register' : 'Already have an account? Login'}
        </button>
      </div>
    </div>
  );
};

export default DatabaseConnectionChecker;
